import './AiModal.scss';

import { AiModalCard } from './AiModalCard';
import classNames from 'classnames';
import { PeriscopeCard } from '@sonar-software/sonar-ts-types';
import { PeriscopeSummary } from '@periscopes/PeriscopeSummary';
import React from 'react';

import { Modal, Space } from 'antd';

export interface AiModalProps {
	className?: string;
	onClose?: () => void;
	open: boolean;
	periscope?: PeriscopeCard;
	salesforceUrl?: string;
	showIcon?: boolean;
	sourceUrl: string;
	title: string;
}

export const AiModal: React.FC<AiModalProps> = ({
	className,
	onClose,
	open,
	periscope,
	salesforceUrl,
	showIcon,
	sourceUrl,
	title
}) =>
	<Modal
		className={ classNames('ai-modal', className) }
		closable
		destroyOnHidden
		footer={ null }
		onCancel={ onClose }
		open={ open }>
		<Space className={ classNames('ai-modal-view', { 'with-periscope': Boolean(periscope) }) }>
			{ periscope && <PeriscopeSummary
				index={ 0 }
				periscope={ periscope } /> }
			<AiModalCard
				// allowDownload={ !periscope }
				onClose={ onClose }
				salesforceUrl={ salesforceUrl }
				showIcon={ showIcon }
				sourceUrl={ sourceUrl }
				title={ title } />
		</Space>
	</Modal>;
